Vue.component("product-list-component", require("./Index.vue").default);
Vue.component("create-salepage-component", require("./Create.vue").default);
Vue.component("product-detail-component", require("./ProductDetailModal.vue").default);
Vue.component(
    "manage-product-component",
    require("./ManageProductSalePage.vue").default
);
